(function(){
    'use strict';

    angular.module('onvio.setup.appearance', [
        'ui.router',
        'pascalprecht.translate',
        'coreFileReaderManager',
        'bluemoon.components.session',
        'bluemoon.components.NavigationUtils',
        'bluemoon.components.Notifications',
        'bluemoon.components.theme',
        'bmPreferenceService',
        'bmImageUploadModal'
    ]);
})(window.angular);
